<script>
import ProductForm from '~/components/product-form'
import capitalize from 'lodash/capitalize'
import ProductMixin from '~/mixins/product.mixin'

export default {
  name: 'SupplierProductForm',
  components: {
    ProductForm,
  },
  mixins: [ProductMixin],
  props: {
    supplierId: {
      type: String,
      default: '',
    },
    sku: {
      type: String,
      default: '',
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    backTo() {
      const { isEdit, supplierId, sku } = this

      return {
        name: isEdit ? 'supplier-product' : 'supplier-details',
        params: isEdit
          ? { supplierId, sku }
          : { id: supplierId, tab: 'catalogue' },
      }
    },
    formComponent() {
      return this.$refs.productForm
    },
  },
  methods: {
    capitalize,
  },
}
</script>

<template>
  <product-form
    ref="productForm"
    :supplier-id="supplierId"
    :sku="sku"
    :back-to="backTo"
    :title="`${isEdit ? 'Edit' : 'Create'} Supplier Product`"
    :is-edit="isEdit"
    type="supplier"
  />
</template>
